// 检测当前页面的协议
const currentProtocol = window.location.protocol;

// 根据当前协议设置baseService
const baseService = currentProtocol === 'https:' ? 'https://lemonwifi.cn' : 'http://lemonwifi.cn';

// 获取所有类型
export const getNewsType = `${baseService}/ws/news/type/all`;

// 分页查询
export const getNewsByPage = `${baseService}/ws/news`;

// 根据ID获取
export const getNewsById = `${baseService}/ws/news/`;

export const uploadFile= `${baseService}/ws/official/upload`;



// WEBPACK FOOTER //
// ./src/util/api.js